import {Axis} from '@models/pages/interactive-data-analysis/interactive-data-analysis-signal-chart-properties';

import {ChartGaugeType} from '@constants/pages/user-defined-page/chart-gauge-type';
import {ChartConstants} from '@constants/pages/chart-constants';
import {Signal} from '@models/dashboard/signal';

export class ChartSignalEntry {
  signalId: number = 0;
  axisId: string = '';
  signalName: string = '';
  signalType: string = '';
  displayedText: string = '';
  label: string = '';
  scale: number = 0;
  unit: string = '';
  precision: number = 0;
  boundaries: Boundaries = new Boundaries();
  colors: Colors = new Colors();
  customRange: boolean = false;
  axisYLabel: string = '';
  axis: Axis = Axis.LEFT;
  minY: number = 0;
  maxY: number = 0;
  gaugeType: string = ChartGaugeType.MODERN;
  transition: boolean = true;

  constructor(signal?: Signal) {
    this.signalId = signal?.id ?? 0;
    this.signalName = signal?.name ?? '';
    this.signalType = signal?.type ?? '';
    this.displayedText = signal?.label ?? '';
    this.label = signal?.label ?? '';
    this.unit = signal?.unit ?? '';
    this.scale = signal?.scale ?? 0;
    this.precision = signal?.decimals ?? 0;
  }
}

export class Boundaries {
  min: number = 0;
  area1End: number = 30;
  area2End: number = 60;
  max: number = 100;
}

export class Colors {
  main: number = 0;
  area1: number = ChartConstants.DEFAULT_CHART_SETTINGS.SIGNAL.COLORS.AREA1;
  area2: number = ChartConstants.DEFAULT_CHART_SETTINGS.SIGNAL.COLORS.AREA2;
  area3: number = ChartConstants.DEFAULT_CHART_SETTINGS.SIGNAL.COLORS.AREA3;

}
